<template>
<div class="chapter">
<div class="inner_page">
<h1 class="BookTitle">Emerald Decision</h1>
<p class="author" style="margin-top:60px;">Craig Thomas <i>writing as</i> David Grant</p>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// EmeraldDecision.vue?493d352c